// WHY THE MODEL DID NOT LOAD - as a value, so the page can say it.
//
// Prod, 2026-09-27: seven of seven timelines since April load no model,
// because the export's file is ABSENT FROM STORAGE. Two different faults
// reach this page and they are not the same problem:
//
//   NO_MODEL_FILE      the fetch resolved with nothing. api/index.js `get()`
//                      returns null for an empty body, so this is the quiet
//                      shape: no data, no error.
//   STORAGE_ERROR_BODY the fetch returned a body that is NOT JSON. R2 answers
//                      a missing key with an XML error document, and that XML
//                      was being handed to JSON.parse - "Unexpected token
//                      '<', \"<?xml vers\"..." - which threw before the viewer
//                      mounted at all. window.__sl did not even exist.
//   FETCH_FAILED       anything else: network, CORS, a 500.
//
// Only the first two mean "the file is gone, re-export". A network blip does
// not, and telling someone to re-export because their wifi dropped wastes an
// export and their trust in the message.
export const NO_MODEL_FILE = 'NO_MODEL_FILE';
export const STORAGE_ERROR_BODY = 'STORAGE_ERROR_BODY';
export const FETCH_FAILED = 'FETCH_FAILED';

// A parse failure is recognised by the SHAPE of the message rather than by
// instanceof: the error crosses a promise boundary and different browsers
// word it differently ("Unexpected token <" in Safari, "is not valid JSON" in
// Chrome), so both spellings are matched.
export function classifyModelFetchError(err) {
  const msg = String((err && err.message) || err || '');
  if (/Unexpected token|not valid JSON|JSON\.parse/i.test(msg)) return STORAGE_ERROR_BODY;
  return FETCH_FAILED;
}

// The file in question is the timeline's ESTIMATE. The 3D does not wait for
// it (it streams the project's live version), so each sentence says the
// model shown is the live one and only the estimate is missing.
export function modelErrorText(code) {
  if (code === STORAGE_ERROR_BODY) {
    return {
      title: "This timeline's estimate could not be read from storage",
      detail: "Storage returned an error instead of the estimate, so its file is not there any more. The model shown is the project's live version. Re-export this project from the desktop app to rebuild the estimate.",
    };
  }
  if (code === FETCH_FAILED) {
    return {
      title: "This timeline's estimate could not be fetched",
      detail: "The model shown is the project's live version. Check the connection, then re-export this project from the desktop app if the estimate does not come back.",
    };
  }
  return {
    title: "This timeline's estimate file is missing",
    detail: "There is no estimate data for this export. The model shown is the project's live version. Re-export this project from the desktop app to rebuild the estimate.",
  };
}
